import { qs } from './domHelpers.js';

export class ModalManager {
  /**
   * Opens a modal identified by the given context.
   * @param {string} context - The context to use for selecting the modal (e.g., "filter", "info").
   */
  static openModal(context) {
    const modal = qs('.modal--' + context);
    if (modal) {
      modal.classList.add('modal-active');
    }
  }

  /**
   * Closes the currently active modal.
   */
  static closeActiveModal() {
    const activeModal = qs('.modal-active');
    if (activeModal) {
      activeModal.classList.remove('modal-active');
    }
  }
}